import { render, staticRenderFns } from "./TODepartmentOverview.vue?vue&type=template&id=37af29f4&scoped=true&"
import script from "./TODepartmentOverview.vue?vue&type=script&lang=js&"
export * from "./TODepartmentOverview.vue?vue&type=script&lang=js&"
import style0 from "./TODepartmentOverview.vue?vue&type=style&index=0&id=37af29f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af29f4",
  null
  
)

export default component.exports